"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointerCircle = void 0;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _reactcss = require("reactcss");
var _reactcss2 = _interopRequireDefault(_reactcss);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle2() {
  var styles = (0, _reactcss2.default)({
    "default": {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return _react2.default.createElement("div", { style: styles.picker });
};
exports.default = ChromePointerCircle;
